

















import { Component, mixins, Prop } from 'nuxt-property-decorator'
import MixinGeneral from '~/assets/mixins/general'
import ComponentHeaderWithLink from '~/components/header/header-with-link.vue'
import { BRANDS_PATH } from '~/assets/config/path'
import { filterUrl } from '~/assets/filters/url'
import { IBrand } from '~/assets/interfaces/brands'
import ComponentBrandItem from '~/components/brands/brand-item.vue'

@Component({
  components: {
    ComponentBrandItem,
    ComponentHeaderWithLink,
  },
  filters: {
    filterUrl,
  },
})
export default class ComponentPageIndexBrandsContent extends mixins(
  MixinGeneral
) {
  @Prop({ type: Array, default: () => [] }) readonly items!: IBrand[]
  @Prop({ type: String, default: '' }) readonly title!: string

  private BRANDS_PATH = BRANDS_PATH
}
